<template>
    <div v-if="true">
        <div @click="$emit('close')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-40 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">ADD DEPENDENT</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Last Name*</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Last Name"     @input="lname = lname.toUpperCase()" v-model="lname" >
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">First Name*</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="First Name"    @input="fname = fname.toUpperCase()" v-model="fname">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Middle Name</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Middle Name"   @input="mname = mname.toUpperCase()" v-model="mname" >
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Relation*</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none"  placeholder="Relationship" @input="relation = relation.toUpperCase()" v-model="relation" >
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Birthdate*</p>
                    <input type="date" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="mm-dd-yyyy"     v-model="birthdate" >
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Contact No.</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="+639XXXXXXXXX" maxlength="13" @input="mobileVerification"  v-model="contact_no">
                </div>
                <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                    <button class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md w-[100px]"  v-if="EditorAdd === 'Edit'" v-on:click="UpdateAccount">Update</button>
                    <button :disabled="disabledbtn" class="text-sm text-white bg-[#006A00] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="$emit('addDependent',fname ,lname ,mname , aname, birthdate, contact_no, relation)">Create</button>
                    <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px]" v-on:click="$emit('close')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from "vue";
// import Services from "../../../services/admin"

export default defineComponent({
components: {
   
},
data() {
    return {
        fname: '',
        lname: '',
        mname: '',
        aname: '',
        birthdate: '',
        contact_no: '',
        relation: '',
    }
},
props: {
     disabledbtn: {
        type: Boolean,
        default: false,
    },
},
methods:{
     mobileVerification(){
        this.contact_no = "+" + this.contact_no.replace(/\D/g, '');
        if (this.contact_no.length < 4)
        {
            this.contact_no = "+639";
        }
    },
    }
})

</script>

<style scoped>
        table tr th{
            background-color: #006A00;
            padding: 15px 0px;
            position:sticky;
            top:0;
        }
        tr td{
            height: 20px;
            text-align: center;
            padding: 10px 1px;
            color: #5f615f;
            border-bottom: 1px solid rgb(177, 175, 175);
            font-weight: 600;

        }
        .loader {
            width: 30px;
            height: 30px;
            border: 5px solid #ffffff;
            border-bottom-color: transparent;
            border-radius: 50%;
       
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
            }
        
            @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
            } 
    </style>